<template lang="pug">
  md-card
    md-card-header(data-background-color="green")
      h4(class="title") Fund Catalog
      p(class="category") Request to join a fund that interests/works for you
    md-card-content(v-if="madeRequest")
      p(style="text-align: center;") You've requested to join a fund! Please wait while your request is being reviewed.
    //- md-card-content(v-else-if="!user.fund_eligible")
      p(style="text-align: center;") Sorry, you must complete a semester of Analyst Group before joining a fund.
    md-card-content(v-else)
      md-table
        md-table-row
          md-table-cell Time
        md-table-row(v-for="group in allGroups" :key="group.fund_id")
          md-table-cell <b>{{group.name}}</b>: {{ group.day }} @ {{ group.hour - 12}} pm 
          md-table-cell
            md-button.md-raised.md-success(@click="openForm(group)") Request to Join
      FundRegisterForm
</template>

<script>
import axios from 'axios';
import FundRegisterForm from './FundRegisterForm.vue';

export default {
  props: {
    user: {
      type: Object,
      default: null,
    }
  },
  components: {
    FundRegisterForm
  },
  data() {
    return {
      allGroups: null,
      error: null,
      madeRequest: null,
      showDialog: false,
      saNames: '',
      saNamesOG: '',
      agTaken: false,
    }
  },
  created() {
    this.$bus.$on('fundRequest:success', () => {
      this.refresh(true);
    })
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh(request_success) {
      if (request_success) {
        this.madeRequest = true;
      } else {
        this.madeRequest = this.$store.state.user.open_fund_request;
      }
      axios.get('/api/org/funds')
      .then((res_fund) => {
        this.allGroups = res_fund.data;
      }).catch((err) => {
        this.error = true;
      })
    },
    openForm(group) {
      this.$bus.$emit('fundRequest:open', group);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Fund/FundRegister.vue